const cards = document.querySelectorAll('.js-scroll-stack-item');

if (cards.length) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    },
    { threshold: 0.15 }
  );

  cards.forEach((card) => {
    observer.observe(card);
  });
}
